import React, { Component } from "react";
import { request, url } from "../../config";
import { translate } from 'react-i18next';
import { Autocomplete, Box, Checkbox, FormControl, FormControlLabel, FormLabel, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { CheckBox, CheckBoxOutlineBlankOutlined, CheckBoxRounded } from "@material-ui/icons";
import { statusCodes } from "../../helpers/statusCodes";

class Create extends Component {
    state = {
        feedbackMessage: null,
        name: "",
        surname: "",
        soname: "",
        number: "",
        isTBCustomer: 0,
        payload: null,
        isCitizen: true,
        check: true,
        finCode: '',
        mail: '',
        file: '',
        prefixId: 0,
        submit: false
    }

    getPhnCategoryAndReqType = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        fetch(url("suggestion/suggestions/getPhnCategoryAndReqType", null, "GET"))
            .then(res => res.text())
            .then((getPhnCategoryAndReqTypeResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getPhnCategoryAndReqTypeResponse = JSON.parse(getPhnCategoryAndReqTypeResponseJSON);
                if (getPhnCategoryAndReqTypeResponse.status.statusCode !== 1) {
                    if (getPhnCategoryAndReqTypeResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        getPhnCategoryAndReqTypeResponse.status.statusCode === statusCodes.ACCESS_DENIED_OPERATION ?
                            this.props.alertState(true, "warning", this.props.t("Information"), this.props.t(getPhnCategoryAndReqTypeResponse.status.statusCode), null, true)
                            :
                            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getPhnCategoryAndReqTypeResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.setState({ payload: getPhnCategoryAndReqTypeResponse.model });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    createSuggestion = (e) => {
        e.preventDefault();
        this.setState({ submit: true });
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let { mail, isTBCustomer, name, surname, soname, finCode, check, number,
            prefixId, isCitizen, suggestionCategory, suggestionText, suggestionType } = this.state;

        if (name && surname && soname && (!mail || emailPattern.test(mail)) &&
            (check ? finCode.length == 7 : finCode) && (isCitizen ? number.length == 7 : number) && (!isCitizen || prefixId != 0)
            && suggestionCategory && suggestionText && suggestionType) {
            this.props.updateAppState('isLoadingTransparentBackground', true);
            let createSuggestionRequestBody = {
                mail, isTBCustomer, name, surname, soname,
                fin: { finCode, check },
                phoneNumber: { number, prefixId, isCitizen },
                lang: localStorage.getItem('i18nextLng').toUpperCase(),
                suggestionText, suggestionType, suggestionCategory
            }
            let data = new FormData();
            data.append('reqObject', JSON.stringify(createSuggestionRequestBody));
            data.append('file', this.state.file);

            fetch(url("suggestion/suggestions/createSuggestionFromSite", data, "POST_FORM"))
                .then(res => res.text())
                .then((createSuggestionResponseJSON) => {
                    const JSON = require('true-json-bigint');
                    let createSuggestionResponse = JSON.parse(createSuggestionResponseJSON);
                    if (createSuggestionResponse.status.statusCode !== 1) {
                        if (createSuggestionResponse.status.statusCode === 200) {
                            this.props.logout();
                        } else {
                            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(createSuggestionResponse.status.statusCode));
                            this.props.updateAppState('isLoadingTransparentBackground', false);
                        }
                    }
                    else {
                        this.props.alertState(true, 'success', this.props.t('successful operation'), createSuggestionResponse.model?.response?.message, null, null, () => this.props.history.push('/feedback/list'));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                },
                    (error) => {
                        this.props.history.push("/technical-break");
                    });
        }
    }

    componentDidMount() {
        this.getPhnCategoryAndReqType();
    }

    render() {
        let { soname, surname, name, isTBCustomer, check, isCitizen, number, payload, finCode, mail, prefixId, suggestionText, submit } = this.state;
        let { t } = this.props;
        return (
            <form onSubmit={this.createSuggestion}>
                <FormControl>
                    <FormLabel>{t('I am a Turanbank customer')}</FormLabel>
                    <RadioGroup row value={isTBCustomer} onChange={(e) => this.setState({ isTBCustomer: e.target.value })}>
                        <FormControlLabel value={1} control={<Radio icon={<CheckBoxOutlineBlankOutlined />} checkedIcon={<CheckBoxRounded />} />} label={t('Yes')} />
                        <FormControlLabel value={0} control={<Radio icon={<CheckBoxOutlineBlankOutlined />} checkedIcon={<CheckBoxRounded />} />} label={t('No')} />
                    </RadioGroup>
                </FormControl>

                <TextField sx={{ width: "100%" }} error={!name && submit} label={t('name')} variant="outlined" value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                <TextField sx={{ width: "100%" }} error={!surname && submit} label={t('surname')} variant="outlined" value={surname} onChange={(e) => this.setState({ surname: e.target.value })} />
                <TextField sx={{ width: "100%" }} error={!soname && submit} label={t('Ancestor name')} variant="outlined" value={soname} onChange={(e) => this.setState({ soname: e.target.value })} />

                <Autocomplete
                    options={payload?.reqSuggestions}
                    getOptionLabel={option => option.name}
                    onChange={(event, newValue) => this.setState({ suggestionType: newValue?.id })}
                    sx={{ width: '47%' }}
                    renderInput={(params) => <TextField {...params} error={!this.state.suggestionType && submit} label={t('Request type')} />} />

                <Autocomplete
                    options={payload?.categories}
                    getOptionLabel={option => option.name}
                    onChange={(event, newValue) => this.setState({ suggestionCategory: newValue?.id })}
                    sx={{ width: '47%' }}
                    renderInput={(params) => <TextField {...params} error={!this.state.suggestionCategory && submit} label={t('Request category')} />} />

                <TextField sx={{ width: "47%" }} label={t('Pin code')} variant="outlined" onChange={(e) => this.setState({ finCode: e.target.value })}
                    helperText={(check && finCode != 7 && submit) ? t('The PIN code must consist of 7 characters') : t('Uncheck if non-resident')}
                    error={check ? (finCode.length != 7 && submit) : (!finCode && submit)}
                    // inputProps={{ maxLength: check ? 7 : null }}
                    value={finCode}
                    InputProps={{
                        endAdornment: <Checkbox checked={check} onChange={(e) => this.setState({ check: e.target.checked })} />
                    }} />

                <TextField sx={{ width: "47%" }} error={mail && !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) && submit}
                    helperText={mail && !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) && t('269')}
                    label={t('Email address')} variant="outlined" value={mail} onChange={(e) => this.setState({ mail: e.target.value })} />

                <div className={`form-element-phone-number ${((isCitizen ? (!prefixId && submit) : false) || (isCitizen ? (number.length != 7 && submit) : (!number && submit))) ? ' error' : ''}`}>
                    <InputLabel sx={{ m: 0, minWidth: '2.3rem', color: isCitizen ? 'black!important' : '#818198!important' }}>{t('+994')}</InputLabel>
                    <FormControl variant="standard" sx={{ pl: 1, borderInline: '1px solid #CDD5E4', width: '7.5rem!important' }}>
                        <Select
                            defaultValue={0}
                            disabled={!isCitizen}
                            value={prefixId}
                            onChange={(e) => this.setState({ prefixId: e.target.value })}
                            error={isCitizen ? (prefixId == 0 && submit) : false}
                        >
                            <MenuItem value={0}>{t('Prefix')}</MenuItem>
                            {payload?.phoneNumberPrefixes?.map(item =>
                                <MenuItem value={item?.id}>{item?.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <TextField placeholder={t('phone number') + " *"} sx={{ width: '100%' }}
                        error={isCitizen ? (number.length != 7 && submit) : (!number && submit)}
                        helperText={(isCitizen && number != 7 && submit) ? '' : (!number && submit) ? '' : t('Uncheck if foreign number')}
                        variant="outlined"
                        inputProps={{ maxLength: isCitizen ? 7 : 20 }}
                        value={number}
                        onChange={(e) => (/^[0-9]*$/.test(e.target.value) || e.target.value == '') && this.setState({ number: e.target.value })}
                        InputProps={{
                            endAdornment: <Checkbox checked={isCitizen}
                                onChange={(e) => this.setState({ isCitizen: e.target.checked, prefixId: e.target.checked ? this.state.prefixId : 0, number: e.target.checked ? this.state.number.substring(0, 7) : this.state.number })} />
                        }} />
                </div>
                <TextField sx={{ width: "100%" }} label={t('Request message')} error={!suggestionText && submit} value={suggestionText} onChange={(e) => this.setState({ suggestionText: e.target.value })} variant="outlined" multiline minRows={5} className="mt-5 mt-sm-3" />
                <div className="form-element-file">
                    <InputLabel sx={{ m: 0, borderRight: '1px solid #CDD5E4' }}>{t('Attach file')}</InputLabel>
                    {this.state.filename &&
                        <TextField type='text' variant="outlined" value={this.state.filename ?? ''}
                            InputProps={{
                                startAdornment: this.state.filename && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path xmlns="http://www.w3.org/2000/svg" d="M11.5 22C9.96667 22 8.66667 21.4667 7.6 20.4C6.53333 19.3333 6 18.0333 6 16.5V6C6 4.9 6.39167 3.95833 7.175 3.175C7.95833 2.39167 8.9 2 10 2C11.1 2 12.0417 2.39167 12.825 3.175C13.6083 3.95833 14 4.9 14 6V15.5C14 16.2 13.7583 16.7917 13.275 17.275C12.7917 17.7583 12.2 18 11.5 18C10.8 18 10.2083 17.7583 9.725 17.275C9.24167 16.7917 9 16.2 9 15.5V6H10.5V15.5C10.5 15.7833 10.5958 16.0208 10.7875 16.2125C10.9792 16.4042 11.2167 16.5 11.5 16.5C11.7833 16.5 12.0208 16.4042 12.2125 16.2125C12.4042 16.0208 12.5 15.7833 12.5 15.5V6C12.5 5.3 12.2583 4.70833 11.775 4.225C11.2917 3.74167 10.7 3.5 10 3.5C9.3 3.5 8.70833 3.74167 8.225 4.225C7.74167 4.70833 7.5 5.3 7.5 6V16.5C7.5 17.6 7.89167 18.5417 8.675 19.325C9.45833 20.1083 10.4 20.5 11.5 20.5C12.6 20.5 13.5417 20.1083 14.325 19.325C15.1083 18.5417 15.5 17.6 15.5 16.5V6H17V16.5C17 18.0333 16.4667 19.3333 15.4 20.4C14.3333 21.4667 13.0333 22 11.5 22Z" fill="#1D1B20" /></svg>,
                                endAdornment: this.state.filename && <button className='dashboard-contact-section-form-button mr-1' onClick={e => this.setState({ file: null, filename: "" })}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path xmlns="http://www.w3.org/2000/svg" d="M6.33333 1H11.6667M1 3.66667H17M15.2222 3.66667L14.5989 13.0171C14.5053 14.42 14.4586 15.1215 14.1556 15.6533C13.8888 16.1216 13.4864 16.498 13.0015 16.7331C12.4506 17 11.7476 17 10.3416 17H7.65836C6.25236 17 5.54936 17 4.99852 16.7331C4.51356 16.498 4.11119 16.1216 3.84443 15.6533C3.54143 15.1215 3.49467 14.42 3.40114 13.0171L2.77778 3.66667M7.22222 7.66667V12.1111M10.7778 7.66667V12.1111" stroke="#FF1058" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></button>
                            }} />}
                    <div className="form-element-file-input">
                        <input type="file" accept=".jpg, .jpeg, .png, .pdf" name="" id="" onChange={e => this.setState({ file: e.target.files[0], filename: e.target.files[0] ? e.target.files[0].name : "" })} />
                        <button>{this.state.filename ? t('change') : t('Choose')}</button>
                    </div>
                </div>
                <button type="submit">{t('Send')}</button>
            </form>
        )
    }
}


export default translate("translation")(Create);